import "core-js/modules/es6.regexp.search";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "suppliersbutt",
  props: {
    interfaceId: {
      type: String,
      default: ""
    },
    // 请求接口方式默认POST
    strmethod: {
      type: String,
      default: "POST"
    },
    propsValue: {
      type: String,
      default: ""
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    appendtobody: {
      type: Boolean,
      default: true
    },
    disableds: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    buttenname: {
      type: String,
      default: ""
    },
    //公司名称
    corporatename: {
      type: String,
      default: ""
    },
    urls: {
      type: String,
      default: ""
    },
    //判断是否要传公司名称
    corporatenamesta: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {}
    },
    title: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data: function data() {
    return {
      loadingbut: false,
      like1: "",
      like2: "",
      arr: "",
      mea: "",
      paces: "",
      sizename: "",
      checkedTxtt: "",
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      filteredList: [],
      innerValue: "",
      keyword: "",
      keyname: "",
      checked: "",
      checkedTxt: "",
      listLoading: false,
      visible: false,
      refreshDataList: []
    };
  },
  watch: {},
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.getData();
    // this.initData()
  },
  methods: {
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      var _query = _objectSpread({}, this.listQuery);
      var query = {};
      for (var key in _query) {
        if (Array.isArray(_query[key])) {
          query[key] = _query[key].join();
        } else {
          query[key] = _query[key];
        }
      }
      var arrlist = "";
      console.log(this.corporatename, "this.corporatename");
      if (this.keyword == "" && this.corporatename == "") {
        arrlist = "";
      } else if (this.keyword == "" && this.corporatename != "") {
        arrlist = "AND COMPANY_NAME='".concat(this.corporatename, "'");
      } else if (this.keyword != "" && this.corporatename == "") {
        arrlist = "AND F_CODE LIKE'%".concat(this.keyword, "%'OR F_NAME LIKE'%").concat(this.keyword, "%'OR MNEMONICS LIKE'%").concat(this.keyword, "%'");
      } else {
        arrlist = "AND (F_CODE LIKE'%".concat(this.keyword, "%'OR F_NAME LIKE'%").concat(this.keyword, "%'OR MNEMONICS LIKE'%").concat(this.keyword, "%')AND COMPANY_NAME='").concat(this.corporatename, "'");
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          WhereSql: arrlist
        }
      }).then(function (res) {
        _this.filteredList = res.data.list;
        _this.listLoading = false;
        _this.total = res.data.pagination.total;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      this.getData();
    },
    reset: function reset() {
      this.keyword = "";
      this.keyname = "";
      this.filteredList = this.list;
      this.search();
    },
    refresh: function refresh() {
      this.keyword = "";
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disableds == true && this.corporatename == "" && this.corporatenamesta == false) {
        this.$message({
          message: "请先输入公司名称",
          type: "warning",
          duration: 1000
        });
      } else if (this.disabled == true && this.corporatenamesta == true) {} else {
        this.checked = this.value;
        this.visible = true;
        if (!this.list.length) {
          // this.keyword = this.innerValue;
          this.search();
        } else {
          this.filteredList = this.list;
        }
      }
    },
    select: function select() {
      var _this2 = this;
      this.$emit("refresh", true);
      this.loadingbut = true;
      this.innerValue = this.checkedTxt;
      for (var key in this.data) {
        if (this.data[key] == undefined) {
          this.data[key] = this.checked;
        }
      }
      request({
        url: this.urls,
        method: this.strmethod,
        data: _objectSpread({}, this.data)
      }).then(function (res) {
        _this2.$message({
          type: "success",
          message: res.msg,
          duration: 1000,
          onClose: function onClose() {
            _this2.visible = false, _this2.$emit("refresh", true);
            _this2.loadingbut = false;
          }
        });
      }).catch(function () {
        _this2.loadingbut = false;
      });
    },
    rowClick: function rowClick(row) {
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
      this.checkedTxtt = row.CUSTOMERNAME;
    }
  }
};